"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

interface ProgressProps
  extends React.HTMLAttributes<HTMLDivElement> {
  value?: number | number[];
}

const Progress = React.forwardRef<
  HTMLDivElement,
  ProgressProps
>(({ className, value, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary transition-all duration-500 ease-in-out"
        style={{
          transform: `translateX(-${100 - (Number(value) || 0)}%)`,
        }}
      />
    </div>
  );
});
Progress.displayName = "Progress";

export { Progress };
